import { RemoteNotificationsData } from 'app/infrastructure/remote-data';
import { endpoint } from './endpoints';
import { ConsentPermission, Consent, Subscription } from 'app/area/user-profile/my-notifications/types';

export const api = {

  loadPermission: (): Promise<ConsentPermission> => {
    return new RemoteNotificationsData(endpoint.loadPermission)
      .resource<ConsentPermission>()
      .single();
  },

  loadConsents: async (recipientId: number): Promise<Consent[]> => {
    return await new RemoteNotificationsData(endpoint.loadConsents(recipientId))
      .resource<Consent[]>()
      .all();
  },

  loadConsent: async (id: number, recipientId: number): Promise<Consent> => {
    return await new RemoteNotificationsData(endpoint.loadConsent(id, recipientId))
      .resource<Consent>()
      .single();
  },

  deleteConsent: async (id: number, recipientId: number) => {
    return new RemoteNotificationsData(endpoint.deleteConsent(id, recipientId))
      .resource()
      .httpDelete(id);
  },

  verifyCode: async (subscription: Subscription): Promise<Subscription> => {
    return await new RemoteNotificationsData(endpoint.verifyCode(subscription.recipientId))
      .resource<Subscription>()
      .create(subscription, false);
  },

  addSubscription: async (subscription: Subscription): Promise<Subscription> => {
    return await new RemoteNotificationsData(endpoint.addSubscription(subscription.recipientId))
      .resource<Subscription>()
      .create(subscription, false);
  },

  updateSubscription: async (id: number, subscription: Subscription): Promise<Subscription> => {
    return await new RemoteNotificationsData(endpoint.updateSubscription(id, subscription.recipientId))
      .resource<Subscription>()
      .save(subscription);
  }
};
